<template>
    <div>

        <config-main-title>
            Material de Amostra
        </config-main-title>

        <div v-if="!em_edicao && service">

            <div class="row mb-3">
                <div class="col col-12 col-md-6">
                    <az-input icon="fas fa-search" v-model="search">
                        <template v-slot:buttonposb>
                            <importacao service="amostra_materiais" @refresh="load()" />
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir {{ short_title }}
                    </button>
                </div>
            </div>

            <table class="table table-sm border-0 table-responsive" v-if="lista_classes && lista_classes.length">
                <tr>
                    <td class="text-nowrap">
                        <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in lista_classes" :key="icx">
                            <span class="badge badge-success mr-1" >
                                {{ classe }}
                            </span>
                        </a>
                    </td>
                </tr>
            </table>

            <div class="row mb-3">
                <div class="col col-12">
                    <importacao service="procedimento_amostra_materiais" @refresh="load()">
                        <template v-slot:button-title>
                            <span class="ml-2">
                                Importar Relação Material x Exame
                            </span>
                        </template>
                    </importacao>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length ) && service">
            <az-empty-state 
                :msg="'Nenhum ' + this.short_title.toLowerCase() + ' identificado.'" 
                icon="fas fa-search"
                :action="'Incluir ' + this.short_title" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length && service">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <span class="badge badge-secondary ml-2">#{{ dado.id_amostra_material }}</span>
                        <span class="badge badge-secondary ml-2" v-if="dado.st_codigo">{{ dado.st_codigo }}</span>
                        <div v-if="dado.js_classes && dado.js_classes.length" class="mr-3">
                            <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                v-for="(tag, itx) in dado.js_classes" :key="itx">
                                <span class="badge badge-success ml-1">
                                    {{ tag }}
                                </span>
                            </a>
                        </div>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <span class="badge badge-secondary mr-3" v-if="dado.st_codigo" title="Código Externo">
                                {{ dado.st_codigo }}
                            </span>
                            <button type="button" class="btn btn-outline-secondary btn-sm" title="Exames Relacionados" @click="ver_exames(dado)">
                                <i class="fa fa-play" aria-hidden="true"></i>
                                <span class="badge badge-secondary ml-1">
                                    {{ dado.procedimento_amostra_materiais_count }}
                                </span>
                            </button>
                        </div>
                    </span>
                </li>
            </div>

            <br><br><br><br><br>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ short_title }}
                            {{ item && item.novo ? '(Novo)' : '' }}
                            <span class="badge badge-secondary ml-2" v-if="item && item.id_amostra_material">
                                #{{ item.id_amostra_material }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Descrição"
                                    required
                                    :validate="validate"
                                    v-model="item.st_amostra_material" />
                            </div>
                            <div class="col col-12">
                                <az-input
                                    label="Código Externo"
                                    :validate="validate"
                                    v-model="item.st_codigo" />
                            </div>
                        </div>

                        <!-- Classificação -->
                        <az-sub-title class="mt-3" title="Classificação" />
                        <div class="row mb-3">
                            <div class="col col-12">
                                <multiselect
                                    v-model="item.js_classes"
                                    :options="options_classes"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTag"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação criada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button v-if="model && campo_id && item" :model="model" :id="item[campo_id]" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Exames -->
        <div class="modal fade" id="examesAmostraModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Exames: {{ item.st_amostra_material }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <span class="badge badge-secondary mb-3" title="Quantidade" v-if="item && item.exames">{{ item.exames.length }}</span>
                        <ul class="list-group">
                            <li class="list-group-item d-flex justify-content-between" v-for="(exame, iex) in item.exames" :key="iex">
                                <div>
                                    <a href="#" @click.prevent="$util.abrirProcedimento(exame.procedimento)" class="card-link">
                                        {{ exame.procedimento.search }}
                                    </a>
                                </div>
                                <div>
                                    <i class="fa fa-check-circle text-success mr-2" aria-hidden="true" v-if="exame.fl_padrao"></i>
                                    <span class="badge badge-secondary">
                                        {{ exame.in_regra_ordem }}
                                    </span>
                                </div>

                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Importacao from '../shared/Importacao.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import Multiselect from 'vue-multiselect';


export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            metadados: null, 
            model: "",
            campo_id: "",
            options_classes: [], 
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        Importacao,
        AzSubTitle,
        Multiselect, 
    },

    computed: { 
        lista_classes: function () { 
            if ( !this.lista || !this.lista.length ) 
                return [];
            
            return _.uniq(
                this.lista.filter(item => item.js_classes)
                    .flatMap(item => item.js_classes)
                    .sort()
            );
        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                })
                .sort((a, b) => { 
                    return a.search > b.search ? 1 : -1 ;
                }) : null;
        }
    },

    methods: { 
        filtrar (texto) { 
            if ( this.search == '"' + texto + '"' ) { 
                this.search = "";
            } else { 
                this.search = '"' + texto + '"';
            }
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        ver_exames (item) { 
            this.item = _.cloneDeep(item);

            this.$util.load(this, { 
                service: 'procedimento_amostra_materiais',
                func: 'index',
                parms: { 
                    where: { 
                        id_amostra_material: item.id_amostra_material, 
                    },
                    cadastro: true, 
                },
                loadTo: res => { 
                    this.item.exames = _.orderBy(res, 'procedimento.search');
                    this.$forceUpdate();
                    $('#examesAmostraModal').modal('show');
                }
            });
        },

        incluir () { 
            this.validate = false;

            let item = {
                id_material: null, 
                st_material: "", 
                material_unidade: { 
                    fl_ativo: true, 
                }
            };

            this.editar (item);
        },
        load () { 
            this.$store.commit('loading', true);

            let query = { q: [
                { 
                    name: this.service + '.index',
                    id: 'lista',
                    parms: { 
                        cadastro: true, 
                    }
                },
                { 
                    name: this.service + '.create',
                    id: 'metadados',
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.lista.status == 200 ) { 
                        this.dados = res.data.lista.data;
                    }

                    if ( res.data.metadados.status == 200 ) { 
                        this.metadados = res.data.metadados.data;
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        },
        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);
            $('#edicaoModal').modal('show');
        },
        atualizar () { 

            this.$util.atualizar(this, { 
                service: this.service,
                dados: { 
                    ...this.item,
                    cadastro: true, 
                },
                modal: 'edicaoModal',
                toast: true, 
                reload: true,
            });

        },
        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$store.commit('loading', true);

            let query = { q: [ 
                { 
                    name: this.service + '.toggle',
                    id: 'toggle',
                    parms: { 
                        ...item,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.toggle.status == 200 ) { 
                        //
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () { 
        this.service = 'amostra_materiais';
        this.title = 'Materiais de Amostra';
        this.short_title = 'Material de Amostra';
        this.model = 'amostraMaterial';
        this.campo_id = 'id_amostra_material';
                
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Material de Amostra", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.loadItem(this, {
            service: this.service,
            func: 'tags',
        })
        .then(res => {
            this.options_classes = res;
        });

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>